export default __webpack_public_path__ + "static/media/Stethoscope.c3fb41f2.svg";